var exports = {
  "kL": "SimplePageSkeleton.module__container___aDBCb3",
  "wx": "SimplePageSkeleton.module__header___aDBCb3",
  "BU": "SimplePageSkeleton.module__headerCompact___aDBCb3",
  "Kh": "SimplePageSkeleton.module__headerLeading___aDBCb3",
  "$s": "SimplePageSkeleton.module__headerActions___aDBCb3",
  "Ge": "SimplePageSkeleton.module__rows___aDBCb3",
  "nM": "SimplePageSkeleton.module__row___aDBCb3",
  "pt": "SimplePageSkeleton.module__rowDetails___aDBCb3",
  "y6": "SimplePageSkeleton.module__channelGroups___aDBCb3",
  "Rf": "SimplePageSkeleton.module__channelGroupHeading___aDBCb3",
  "S7": "SimplePageSkeleton.module__channelCard___aDBCb3",
  "Fp": "SimplePageSkeleton.module__channelCardHeader___aDBCb3",
  "ut": "SimplePageSkeleton.module__channelCardStream___aDBCb3",
  "P9": "SimplePageSkeleton.module__channelCardFooter___aDBCb3",
  "YX": "SimplePageSkeleton.module__tableContent___aDBCb3",
  "KE": "SimplePageSkeleton.module__toolbar___aDBCb3",
  "d0": "SimplePageSkeleton.module__toolbarLeft___aDBCb3",
  "O5": "SimplePageSkeleton.module__toolbarRight___aDBCb3",
  "wY": "SimplePageSkeleton.module__tableWrapper___aDBCb3",
  "p": "SimplePageSkeleton.module__tableViewport___aDBCb3",
  "uV": "SimplePageSkeleton.module__tableSurface___aDBCb3",
  "QS": "SimplePageSkeleton.module__tableSurfaceSelectable___aDBCb3",
  "iA": "SimplePageSkeleton.module__tableFooter___aDBCb3",
  "vl": "SimplePageSkeleton.module__tableFooterLeft___aDBCb3",
  "C5": "SimplePageSkeleton.module__tableFooterRight___aDBCb3",
  "tT": "SimplePageSkeleton.module__tableHeadRow___aDBCb3",
  "ts": "SimplePageSkeleton.module__tableHeadCell___aDBCb3",
  "bg": "SimplePageSkeleton.module__tableBody___aDBCb3",
  "jD": "SimplePageSkeleton.module__tableRow___aDBCb3",
  "xR": "SimplePageSkeleton.module__tableCell___aDBCb3",
  "MN": "SimplePageSkeleton.module__tableNameCell___aDBCb3",
  "mg": "SimplePageSkeleton.module__tableNameInfo___aDBCb3",
  "Yo": "SimplePageSkeleton.module__tableActionsCell___aDBCb3",
};

module.exports = exports;
